import { useEffect } from 'react';
import { Outlet, useMatch } from 'react-router-dom';

import { useNavigateWithHealthProvider } from '../../data/utils/router.utils';
import { CustomFormattedMessage } from '../../elements/intl/custom-formatted-message';
import { Sidebar } from '../../elements/sidebar/sidebar';
import { SidebarList } from '../../elements/sidebar-list/sidebar-list';
import { SidebarListItem } from '../../elements/sidebar-list/sidebar-list-item';

export function AdminPage() {
  const navigate = useNavigateWithHealthProvider();

  const isAdminPage = useMatch('/:wildcard/admin');
  useEffect(() => {
    if (isAdminPage) {
      navigate('/admin/users');
    }
  }, [navigate, isAdminPage]);

  return (
    <>
      <Sidebar title={<CustomFormattedMessage id="admin.title" />}>
        <SidebarList
          items={[
            <SidebarListItem
              key="users"
              title={<CustomFormattedMessage id="admin.users.title" />}
              active={!!useMatch('/:wildcard/admin/users')}
              onClick={() => navigate('/admin/users')}
            />,
            <SidebarListItem
              key="templates"
              title={<CustomFormattedMessage id="admin.templates.title" />}
              active={!!useMatch('/:wildcard/admin/templates')}
              onClick={() => navigate('/admin/templates')}
            />,
            <SidebarListItem
              key="honorific-block-times"
              title={
                <CustomFormattedMessage id="admin.honorific-block-times.title" />
              }
              active={!!useMatch('/:wildcard/admin/honorific-block-times')}
              onClick={() => navigate('/admin/honorific-block-times')}
            />,

            <SidebarListItem
              key="features"
              title={<CustomFormattedMessage id="admin.features.title" />}
              active={!!useMatch('/:wildcard/admin/features')}
              onClick={() => navigate('/admin/features')}
            />,
            <SidebarListItem
              key="opening-hours"
              title={<CustomFormattedMessage id="admin.opening-hours.title" />}
              active={!!useMatch('/:wildcard/admin/opening-hours')}
              onClick={() => navigate('/admin/opening-hours')}
            />,
            <SidebarListItem
              key="health-provider-translations"
              title={
                <CustomFormattedMessage id="admin.health-provider-translations.title" />
              }
              active={
                !!useMatch('/:wildcard/admin/health-provider-translations')
              }
              onClick={() => navigate('/admin/health-provider-translations')}
            />,
          ]}
        />
      </Sidebar>

      <Outlet />
    </>
  );
}
